import { isEmpty, union } from 'lodash';

import { alphabetizeBy } from '@ion/mrdash';

import {
  useEventDebuggerTableContext,
  FILTER_KEYS,
} from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const STATIC_PIPELINE_SELECT_PROPS = {
  size: 'small',
  variant: 'outlined',
  label: 'Pipelines',
};

export default function useEventDebuggerPipelineSelectProps() {
  const { cluster, filters, filterOptions, filterOptionsLoading, updateFilter, pipelinesByWritekey } =
    useEventDebuggerTableContext();

  const onChange = selectedPipelines => {
    updateFilter({ [FILTER_KEYS.WRITEKEYS]: selectedPipelines });
  };

  const props = {
    ...STATIC_PIPELINE_SELECT_PROPS,
    options: buildOptions({
      writekeys: union(filterOptions?.writekeys, filters[FILTER_KEYS.WRITEKEYS]),
      pipelinesByWritekey,
    }),
    disabled: filterOptionsLoading || !cluster,
    key: `${cluster}-pipelines`,
    value: filters[FILTER_KEYS.WRITEKEYS],
    onChange,
  };

  return props;
}

function buildOptions({ writekeys, pipelinesByWritekey }) {
  if (isEmpty(writekeys)) {
    return [{ label: 'No pipelines available', value: '', disabled: true }];
  }

  const options = writekeys.map(writekey => ({
    label: pipelinesByWritekey[writekey] ?? writekey,
    value: writekey,
  }));

  return alphabetizeBy(options, 'label');
}
